import React from 'react';

function TestEmail() {
  const sendEmail = () => {
    fetch('http://localhost:5002/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        to: "pablodunovits@gmail.com",
        subject: "Pabs - New User Registration",
        text: "Testing some Mailgun awesomeness!",
        html: "<h1>Testing some Mailgun awesomeness!</h1>"
      })
    })
      .then(response => {
        console.log("Response status:", response.status);
        return response.json();
      })
      .then(data => console.log("Email sent:", data))
      .catch(error => console.error("Error sending email:", error));
  };

  return (
    <div>
      <h2>Test Email</h2>
      <button onClick={sendEmail}>Send Test Email</button>
    </div>
  );
}

export default TestEmail;
